module.exports = __webpack_public_path__ + "static/media/DMSans-Italic.5932d80b.ttf";